<template>
  <div class="traceabilityCode">
    <el-menu :default-active="tabActive.toString()" mode="horizontal" @select="tabSelect">
      <template v-for="(item, index) in tabList">
        <el-menu-item :index="index.toString()">{{ item.name }}</el-menu-item>
      </template>
    </el-menu>
    <div class="content">
      <component :is="tabList[tabActive].component"></component>
    </div>
  </div>
</template>

<script>
  import inventoryInquiry from './components/inventoryInquiry.vue'
  import salesReport from './components/salesReport.vue'
  export default {
    name: 'traceabilityCode',
    components: {
      inventoryInquiry,
      salesReport
    },
    data() {
      return {
        tabActive: 0,
        tabList: [
          { id: 1, name: '库存追溯码', component: 'inventoryInquiry' },
          { id: 2, name: '追溯码销售上报', component: 'salesReport' }
        ]
      }
    },
    methods: {
      tabSelect (index) {
        this.tabActive = index
      }
    }
  }
</script>

<style lang="less" scoped>
  .traceabilityCode{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
  }

  .content {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    min-height: 0px;
  }

</style>
